import { createFileRoute, Outlet } from "@tanstack/react-router";

import { SensoryProfilePage } from "@/components/sensory-profile/sensory-profile-page";
import { SensoryProfileSessionProvider } from "@/components/sensory-profile/sensory-profile-session";

export const Route = createFileRoute("/sensory-profile")({
  component: SensoryProfileLayout,
});

function SensoryProfileLayout() {
  return (
    <SensoryProfilePage>
      <SensoryProfileSessionProvider>
        <Outlet />
      </SensoryProfileSessionProvider>
    </SensoryProfilePage>
  );
}
